import { makeLocalFavoriteStore } from 'Workspace/storage/makeLocalFavoriteStore';

const store = makeLocalFavoriteStore({
  favoriteKeysPrefix: 'workspace.publications.favoritePublicationKeys',
  allExpandedPrefix: 'workspace.publications.allPublicationsExpanded',
  favoriteKeysParseErrorLabel: 'Failed to parse stored workspace favorite publication keys',
  allExpandedParseErrorLabel: 'Failed to parse stored all publications expanded state',
});

export const getWorkspaceFavoritePublicationKeysStorageKey = store.getFavoriteKeysStorageKey;
export const getAllPublicationsExpandedStorageKey = store.getAllExpandedStorageKey;
export const loadFavoritePublicationKeys = store.loadFavoriteKeys;
export const saveFavoritePublicationKeys = store.saveFavoriteKeys;
export const loadAllPublicationsExpanded = store.loadAllExpanded;
export const saveAllPublicationsExpanded = store.saveAllExpanded;

/**
 * Stable key for a publication row (must match favorites storage).
 * @param {{ activityId: string, outputType: string, market?: string|null }} pub
 * @returns {string}
 */
export const getPublicationUniqueKey = (pub) =>
  `${pub.activityId}${pub.outputType}${pub?.market || ''}`;
